export default "__VITE_ASSET__CX1QxY73__"